module.exports = __webpack_public_path__ + "static/media/12.a79029f8.png";